/* Models */
export { ImportResult as MagentoImportResult } from "@model";

/* Environments */
export { MagentoEnv as MagentoEnv } from "@environment";

/* Resources */
export { BaseResource as BaseMagentoResource } from "@resource";
export { ImportResource as MagentoImportResource } from "@resource";

/* Request */
export { Request as MagentoRequest } from "@resource";

/* Types */
export { TIntegrationRunTypes as MagentoIntegrationRunTypes } from "@types";

/* Init environment */
import { MagentoEnv, envSelector } from "@environment";
export const initEnv = (selectedStore: MagentoEnv): any => {
	envSelector.initEnv(selectedStore);
};